import Home from '@/pages/Home'

// export default {
//   path: '/',
//   name: 'Home',
//   component: Home,
// }



export default {
  path: '/',
  name: 'Home',
  component: Home,
  children: [
    {
      path: 'go/:menu',
      name: 'Home2',
      component: Home
    }
  ]
}


// export default {
//     path: '/',
//     name: 'Home',
//     component: function() {
//         var reg = new RegExp("www.sellpoints.com.ng|test|localhost:2082");
//         var parts = window.location.host.split(".");
//         //return Home;
//         // return reg.test(parts[0]) ? require('@/pages/Home') : require('@/pages/Points');
//         return reg.test(parts[0]) ? require('@/pages/Home') : require('@/pages/Sellpoint/Sellpoint');
//     }()
// }

// export default {
//     path: '/',
//     name: 'Home',
//     component: function() {
//         var reg = new RegExp("www|sitename|test|localhost:2082");
//         var parts = window.location.host.split(".");
//         //return Home;
//         return reg.test(parts[0]) ? require('@/pages/Home') : require('@/pages/Points');
//     }()
// }


// WEBPACK FOOTER //
// ./src/router/home.js